import dayjs from "dayjs";
import "dayjs/locale/bs";
import IModuleContainer from "./runtime/IModuleContainer";
import ModuleContainer from "./runtime/ModuleContainer";
import { ILocaleProvider } from "./service/locale/LocaleProvider";
import { IStore } from "./model/runtime/state/Store";
import { IRouter, Router } from "./runtime/Router";
import { IArea } from "./areas/Area";
import { Action, To } from "history";
import HandleApplicationErrorInteractor from "./interactor/main/HandleApplicationErrorInteractor";

export default class Application {
  private _router: IRouter;
  private _container: IModuleContainer;
  private _localeProvider: ILocaleProvider;

  private _areas = ["home", "payment", "device", "authentication"];

  get container() {
    return this._container;
  }

  get navigator() {
    return this._router;
  }

  get localeProvider() {
    return this._localeProvider;
  }
  constructor(context: any, rootElement: HTMLElement) {
    this._container = ModuleContainer(this);
    this._router = Router(context, rootElement, this, []);
    this._container.registerValue("router", this._router);
    this._localeProvider =
      this.container.resolve<ILocaleProvider>("localeProvider");

    dayjs.locale(this._localeProvider.getCurrentLanguage());
    window["__secretApplication"] = this;
  }

  private registerGlobalErrorHandler() {
    const _container = this.container;
    window.addEventListener("unhandledrejection", function (e) {
      var reason = e.reason ? e.reason : e.type;

      e.preventDefault();
      if (!(e as any).reason.handled) {
        _container
          .resolve<HandleApplicationErrorInteractor>("handleApplicationError")
          .execute(reason);
      }
    });
  }

  public changeSystemLanguage(languageCode: string) {
    this._container.registerValue("language", languageCode);
  }

  private registerAreas(areas: string[]) {
    areas.forEach((area) => {
      this._container.resolve<IArea>(`${area}Area`).register();
    });
  }

  async start() {
    this.registerAreas(this._areas);
    this._router.bindLocationListener();
    this._router.showLocation({
      action: Action.Push,
      location: {
        pathname: window.location.pathname,
        search: window.location.search
      }
    }) as To;

    this.registerGlobalErrorHandler();
  }

  public get store() {
    return this._container.resolve<IStore>("store");
  }

  addLocale(locale: string, translations = {}) {
    if (locale) {
      this.localeProvider.addLocale(locale, translations);
    }
  }
}
